import React, { useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Header from './components/Header';
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import DiceTracker from './pages/DiceTracker';
import BankTracker from './pages/BankTracker';
import Leaderboard from './pages/Leaderboard';
import Membership from './pages/Membership';
import Teams from './pages/Teams';
import About from './pages/About';
import Admin from './pages/Admin';



function App() {
  const navigate = useNavigate();

  // Configure axios base URL for backend API
  // In development, use relative URLs (proxied by setupProxy.js)
  // In production, the nginx config handles /api routing
  if (process.env.NODE_ENV === 'production') {
    axios.defaults.baseURL = 'http://localhost:7500';
  }
  // In development, leave baseURL undefined so relative URLs work with proxy

  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${storedToken}`;
    }
    return storedToken;
  });
  const [userData, setUserData] = useState(() => {
    const storedUserData = localStorage.getItem('userData');
    return storedUserData ? JSON.parse(storedUserData) : null;
  });

const login = (newToken, userData) => {
  setToken(newToken);
  setUserData(userData);
  localStorage.setItem('token', newToken);
  localStorage.setItem('userData', JSON.stringify(userData));
  axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
};

const logout = () => {
  setToken(null);
  setUserData(null);
  localStorage.removeItem('token');
  localStorage.removeItem('userData');
  delete axios.defaults.headers.common['Authorization'];
  navigate('/');
};

  return (
    <>
      <Header user={userData} logout={logout} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register login={login} />} />
        <Route path="/login" element={<Login login={login} />} />
        <Route path="/dice-tracker" element={token ? <DiceTracker /> : <Navigate to="/login" />} />
        <Route path="/bank-tracker" element={token ? <BankTracker /> : <Navigate to="/login" />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/membership" element={token ? <Membership /> : <Navigate to="/login" />} />
        <Route path="/teams" element={token ? <Teams /> : <Navigate to="/login" />} />
        <Route path="/about" element={<About />} />
        <Route path="/admin" element={token && userData?.role === 'admin' ? <Admin /> : <Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;